import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Link,
  Box,
  Fade
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AppleIcon from '@mui/icons-material/Apple';
import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly';

const IosAppPage = () => {
    return (
        <>
            <Fade in timeout={800}>
              <Container sx={{ py: 4 }}>
                <Typography variant="h4" color="primary" gutterBottom>
                  📣 CCOO.ca Is Now Live on the App Store!
                </Typography>
                <Typography variant="h5" gutterBottom>
                  Shop Smart. Ship Fast. Stay Canadian — now in your pocket.
                </Typography>
                <Typography paragraph>
                  We’re thrilled to announce that the <strong>CCOO.ca app is officially live on the App Store</strong>! Whether you're browsing our curated catalog, discovering new Canadian-made essentials, or tapping through to Amazon for fast checkout, the experience is now smoother, faster, and mobile-first.
                </Typography>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h6" gutterBottom>
                  🚀 What’s Inside:
                </Typography>
                <List>
                  {[
                    'Browse our full product lineup',
                    'One-tap Amazon checkout',
                    'Track featured drops and seasonal collections',
                    'Stay connected to a proudly Canadian brand'
                  ].map((feature, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <CheckCircleIcon color="success" />
                      </ListItemIcon>
                      <ListItemText primary={feature} />
                    </ListItem>
                  ))}
                </List>

                <Divider sx={{ my: 4 }} />

                <Typography variant="h6" gutterBottom>
                  📱 Download Now
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <AppleIcon color="primary" />
                  <Typography>
                    <Link href="#" target="_blank" rel="noopener">
                      Get it on the App Store
                    </Link>{' '}
                    — Available for iPhone and iPad
                  </Typography>
                </Box>

                <Divider sx={{ my: 4 }} />

                <Typography variant="body2" color="text.secondary">
                  Questions or feedback? Reach us at{' '}
                  <Link href="mailto:support@ccoo.ca">support@ccoo.ca</Link>
                </Typography>
              </Container>
            </Fade>
        </>
    )
}
export default IosAppPage;